import { useEffect, type PropsWithChildren } from 'react';
import { dynamicI18n } from 'features/i18n/DynamicTranslation/dynamicI18n';
import { logger } from 'features/logger/logger';
import { useAppDispatch, useAppSelector } from 'features/store/hooks';
import { DynamicTranslationContext } from './DynamicTranslationContext';
import { loadDynamicTranslationNamespaces } from './store/dynamicTranslationThunks';
import type { RootState } from 'features/store/store';

type Props = PropsWithChildren;

export const DynamicTranslationProvider = ({ children }: Props) => {
  const dispatch = useAppDispatch();
  const language = useAppSelector(
    (state: RootState) => state.dynamicTranslation.language
  );
  const loadedNamespaces = useAppSelector(
    (state: RootState) => state.dynamicTranslation.loadedNamespaces
  );
  const requiredNamespaces = useAppSelector(
    (state: RootState) => state.dynamicTranslation.requiredNamespaces
  );

  useEffect(() => {
    logger.debug('Loading required namespaces in provider (effect)', {
      details: requiredNamespaces,
    });
    void dispatch(loadDynamicTranslationNamespaces(requiredNamespaces));
  }, [dispatch, requiredNamespaces]);

  return (
    <DynamicTranslationContext.Provider
      value={{
        dynamicI18n: dynamicI18n,
        language,
        loadedNamespaces,
      }}
    >
      {children}
    </DynamicTranslationContext.Provider>
  );
};
